import React, { useEffect, useState } from 'react'
import CheckboxInput from '../../common/inputs/CheckboxInput'

const InstallationCalenderFilter = ({ data, setData }) => {

    const [form, setForm] = useState(data || [])

    const statusList = [
        { title: 'Pending', index: 1 },
        { title: 'Follow up', index: 2 },
        { title: 'Scheduled', index: 3 },
        { title: 'Completed', index: 4 },
        // { title: 'Cancelled', index: 5 },
        { title: 'Cancelled', index: 6 }
    ]

    const handleCheckBox = (e) => {
        const value = Number(e.target.value);

        setForm((prevState) => {
            if (e.target.checked) {
                return [...prevState, value];
            } else {
                return prevState.filter((item) => item !== value);
            }
        });
    }

    useEffect(() => {
        setData(form)
        // eslint-disable-next-line
    }, [form])

    return (
        <div className="calendar-filter-comp-div">
            {statusList?.map((status) => <CheckboxInput key={status.title} label={status.title} onChangeFun={handleCheckBox}
                name={'status'} checked={form?.includes(status?.index)} value={status.index} />)}
        </div>
    )
}

export default InstallationCalenderFilter